import * as React from 'react';
import { generateRoute, translate } from "@js/common/helpers";
var DescriptionBlock = function () {
    var membershipIndexUrl = generateRoute('membership_index');
    var translation = translate('report.notice', {
        'MEMBERSHIP_INDEX_URL': membershipIndexUrl
    }, 'app');
    return (React.createElement("div", { className: "tds text-center mt-4 mb-2 col-12 mt-md-5 mb-md-4 col-md-6 mx-auto" },
        React.createElement("h1", null, translate('report.title.global', {}, 'app')),
        React.createElement("p", null, translate('report.description.premium', {}, 'app')),
        React.createElement("p", { className: "mb-0 report-purchase-notice", dangerouslySetInnerHTML: { __html: translation } })));
};
export { DescriptionBlock };
